module.exports = __webpack_public_path__ + "static/media/banner_marketing.beafc068.png";